export default __webpack_public_path__ + "static/hayallerini_finanse_et-adb60370321601cc374b9d438d8a8162.svg";